import { Injectable, inject } from '@angular/core';
import { FileApi } from 'src/api/file.api';
import { FileBaseService } from './file-base.service';

@Injectable()
export class SupportBundleService extends FileBaseService {
  constructor() {
    const fileApi = inject(FileApi);

    super('SupportBundle', fileApi);
  }
}
